import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  viewBox: "0 0 38 28",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M25.333 14.597a.618.618 0 0 0-.178-.456L18.19 7.16a.616.616 0 0 0-.456-.179.616.616 0 0 0-.455.179l-6.947 6.96c-.132.16-.198.318-.198.477 0 .185.06.337.179.456.118.119.27.178.455.178H15.2v6.981c0 .172.063.321.188.447a.608.608 0 0 0 .445.188h3.8c.172 0 .32-.063.446-.188a.61.61 0 0 0 .188-.447v-6.98H24.7c.172 0 .32-.063.445-.189a.61.61 0 0 0 .188-.446ZM38 20.308c0 2.103-.742 3.898-2.227 5.385-1.484 1.487-3.275 2.231-5.373 2.231H8.867c-2.441 0-4.53-.87-6.264-2.608C.868 23.578 0 21.486 0 19.04c0-1.719.462-3.305 1.385-4.76a8.668 8.668 0 0 1 3.721-3.272c-.026-.397-.04-.68-.04-.853 0-2.803.99-5.196 2.97-7.18C10.014.993 12.402 0 15.2 0c2.058 0 3.942.575 5.65 1.725a9.943 9.943 0 0 1 3.731 4.582c.937-.82 2.032-1.23 3.286-1.23 1.398 0 2.592.496 3.582 1.488.99.991 1.484 2.188 1.484 3.59a4.86 4.86 0 0 1-.811 2.736 7.486 7.486 0 0 1 4.225 2.688C37.45 16.96 38 18.537 38 20.309Z",
      fill: "currentColor"
    }, null, -1)
  ]))]))
}
export default { render: render }